import { filterEvents } from './modules/data.js';
import { lib } from './modules/lib.js';
import { renderEvents, renderNoEvents, setTruncation } from './modules/structure.js';

const observer = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		const ctr = entry.target;
		if (entry.isIntersecting) {
			fetch(ctr.dataset.restEndpoint)
				.then((response) => response.json())
				.then((data) => {
					let events = data.events;

					if (ctr.dataset.events !== 'single_event') {
						// If the event is not a single event, we need to filter it to get the events we have specified in the data attribute.
						events = filterEvents(ctr.dataset.timeFilter, data.events);
					} else if (ctr.dataset.events === 'single_event' && data.events.find((event) => event.repeating)) {
						// If the event is repeating, we need to filter it to get the next upcoming date.
						events = filterEvents('upcoming_events', data.events);
					}

					if (events.length) {
						renderEvents(ctr, data.labels, events);
					} else {
						renderNoEvents(ctr, data.labels.no_data);
					}

					observer.unobserve(ctr);

					setTruncation(ctr);
				})
				.catch((error) => {
					console.error(error);
					return false;
				});
		}
	});
});

const containers = document.querySelectorAll(lib.selectors.events);

containers.forEach((ctr) => {
	// Skip navigation event containers - they are handled by event-nav.js
	if (ctr.closest('.stage.stage--event')) {
		return;
	}

	observer.observe(ctr);
});
